export const CONNATIX_LATE_INJECT = {
	name: 'Connatix late inject',
} as const;
export const CONNATIX_READY = {
	name: 'Connatix ready',
} as const;
